import { render, staticRenderFns } from "./AdminOrganization.vue?vue&type=template&id=39ae99c9&scoped=true&"
import script from "./AdminOrganization.vue?vue&type=script&lang=js&"
export * from "./AdminOrganization.vue?vue&type=script&lang=js&"
import style0 from "./AdminOrganization.vue?vue&type=style&index=0&id=39ae99c9&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ae99c9",
  null
  
)

export default component.exports